<template>
  <b-container v-if="done">
    <b-card no-body>
      <b-card-header v-if="done.data.valt_onder !== null">
        <b-card-title>{{ done.data.valt_onder.titel }}</b-card-title>
      </b-card-header>
      <b-card-header v-else>
        <b-card-title>{{ done.titel }}</b-card-title>
      </b-card-header>
      <b-card-body>
        {{ done.unit_adres }}
        {{ done.titel }}
      </b-card-body>
    </b-card>

    <unit 
      v-if="done.data.unit" 
      :unit="done.data.unit"
    />

    <b-input-group 
      prepend="Wanneer" 
      class="my-2" 
      size="lg"
    >
      <b-form-datepicker 
        v-model="done.data.datum"
        dark
        class="dark "
      />
    </b-input-group>

    <b-form-group 
      v-if="isInspectie"
      class="my-4" 
      description="Markeer hierboven om welke inspectie het gaat."
      label-size="lg"
      label="Inspectie ter controle"
    >
      <b-alert 
        v-if="filteredInspections.length == 0"
        variant="danger" 
        show
      >
        Een inspectie voor {{ done.titel }} niet gevonden!
        <small> Alleen binnen de laatste 30 inspecties wordt gezocht</small>
      </b-alert>
      <b-select 
        v-else
        v-model="done.data.inspectie"
        :state="done.data.inspectie != null"
        :options="filteredInspections.map(i => {
          return {
            text: `${i.Unit.Kenmerk} - ${i.Unit.Adres} op ${moment(i.Datum).format('L')} `,
            value: i.Id
          }
        })" 
        size="lg"
      />
    </b-form-group>
    
    <b-form-group 
      v-if="!isInspectie" 
      label="Bijlagen" 
      class="mt-3"
    >
      <secure-bijlagen 
        :bijlagen="done.data.bijlagen" 
      />
    </b-form-group>

    <b-form-group>
      <b-form-checkbox 
        v-model="done.data.voltooid"
        :disabled="voltooidDisabled" 
        size="lg"
      >
        Taak voltooid
      </b-form-checkbox>
    </b-form-group>
  </b-container>
</template>
<script>
import SecureBijlagen from '../SecureBijlagen.vue'
import Unit from '../trajecten/Unit.vue'
export default {
    name: 'Todo',
    components: {Unit,SecureBijlagen},
    mixins: [],
    props: {
      done: {
        type: Object,
        default: null
      },
      inspecties: {
        type: Array,
        default: () => []
      }
    },
    data() {
        return  {
          
        }
    },
    computed: {
      isInspectie: function () {
        if (this.done.data.type == 'NulInspectie') return true;
        if (this.done.data.type == 'Herinspectie') return true;
        return false
      },
      voltooidDisabled: function ( ) {
        if (this.isInspectie && this.done.data.inspectie == null) return true;
        return false
      },
      filteredInspections: function () {
      // if (this.done == null) return this.inspecties
      if (this.done.data.type == 'Herinspectie') return this.inspecties.filter(f => f.Unit.Id == this.done.data.unit.id)
      return this.inspecties
    },
    },
    watch: {},
    mounted () {
        
    },
    methods: {},
          

}
</script>